import { Container, ContainerProps } from '@mui/material';

export const DefaultContainer = (props: React.PropsWithChildren<ContainerProps>) => {
  return <Container maxWidth={'xl'}>{props.children}</Container>;
};
